module.exports = __webpack_public_path__ + "img/checked-user-male.b85ce539.png";